<template>
  <div
    class="sn-bs-wrapper"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <main class="sn-bs-wrapper__main" v-if="!loading && hasData">
      <section class="sn-bs-wrapper__section">
        <el-progress
          type="circle"
          :percentage="percentage"
          status="success"
          color="rgba(44, 234, 132, 0.8)"
          :show-text="false"
          :width="150"
          :stroke-width="8"
        ></el-progress>
        <div class="sn-bs-wrapper__center-text">
          <p class="sn-bs-wrapper__p">地块使用率</p>
          <p class="sn-bs-wrapper__p" v-if="allLandAcre !== 0">
            <span>{{ percent }}</span>
            <span>%</span>
          </p>
          <p class="sn-bs-wrapper__p" v-else>
            <span>--</span>
          </p>
        </div>
      </section>
      <div class="sn-bs-legend__container">
        <div class="sn-bs-legend__item">
          <p>地块总面积</p>
          <p>
            <span>{{ allLandAcre }}</span
            ><span>亩</span>
          </p>
        </div>
        <div class="sn-bs-legend__item">
          <p>当前种养面积</p>
          <p>
            <span>{{ allLandAcreOnPlanting }}</span
            ><span>亩</span>
          </p>
        </div>
      </div>
    </main>
    <empty v-if="!loading && !hasData"></empty>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Empty from "@/components/bs/BsBoxPanel/Empty";

import { farm } from "@/api/request/snkd.produce";

import { maxDecimalPlaces } from "@/utils";

export default {
  name: "ProductionResources",
  components: { Empty },
  data() {
    return {
      loading: false,
      percentage: 0,
      percent: 0,
      allLandAcre: 0,
      allLandAcreOnPlanting: 0,
      hasData: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initMoudle();
    });
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  methods: {
    async initMoudle() {
      this.loading = true;
      try {
        const res = await farm.statisticsFarmAcreAndOnPlantingAcreService({
          companyId: this.companyId,
          farmId: this.farmId,
        });

        if (res) {
          if (res.allLandAcreOnPlanting) {
            this.percentage = maxDecimalPlaces(
              (res.allLandAcreOnPlanting / res.allLandAcre) * 100,
              0
            );
            this.percent = maxDecimalPlaces(
              (res.allLandAcreOnPlanting / res.allLandAcre) * 100,
              2
            );
          } else {
            this.percentage = 0;
            this.percent = 0;
          }

          this.allLandAcre = res.allLandAcre;
          this.allLandAcreOnPlanting = res.allLandAcreOnPlanting;
        } else {
          this.hasData = false;
        }

        this.loading = false;
      } catch (error) {
        this.hasData = false;
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  @include utils-full-box();

  @include e(main) {
    @include utils-full-box();
    display: flex;

    @include e(section) {
      flex: 1;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      @include e(center-text) {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 122px;
        height: 122px;
        background-image: radial-gradient(
          rgba(20, 81, 59, 0.3) 30%,
          #13452e 70%
        );
        border: 1px solid #13452e;
        border-radius: 50%;

        @include e(p) {
          text-align: center;
          @include pseudo(first-child) {
            color: $--color-white;
            font-size: $--font-size-medium;
            font-weight: bold;
          }
          @include pseudo(nth-child(2)) {
            margin-top: 8px;
            color: $--color-text-yellow;
            font-size: 30px;
            font-weight: bold;

            span {
              @include pseudo(nth-child(2)) {
                color: $--color-text-yellow;
                font-size: $--font-size-medium;
              }
            }
          }
        }
      }
    }

    @include bs(legend) {
      @include e(container) {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        width: 40%;
        height: 100%;

        @include e(item) {
          margin-bottom: 40px;

          @include pseudo(last-child) {
            margin-bottom: 0;
          }

          p {
            @include pseudo(nth-child(1)) {
              color: #9dd1d7;
              font-size: $--font-size-large;
              font-weight: bold;
            }

            @include pseudo(nth-child(2)) {
              margin-top: 8px;
              color: $--color-primary;
              font-size: 24px;
              font-weight: bold;

              span {
                @include pseudo(nth-child(2)) {
                  font-size: $--font-size-medium;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
